/**
 * Nmeth Proposal Service
 * 方法論提案申請表 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nmeth-proposal';

// ========== Types ==========

export interface AttachmentChecks {
  draft_pdd: boolean;
  draft_poa_dd: boolean;
  meth_form_002: boolean;
  additional_info: boolean;
  additional_description: string;
}

export interface NmethProposalDetail {
  id: number;
  organization_id: number;
  type_of_standard: number | null;
  title: string;
  mitigation_type: number | null;
  sectoral_scopes: number[] | null;
  project_title: string | null;
  attachment_checks: AttachmentChecks | null;
  proponent_name: string;
  affiliation: number;
  authorized_officer: string | null;
  contact_info: string | null;
  submission_date: string | null;
  signature: string | null;
  status: number;
  meth_proposal_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NmethProposalCreate {
  title: string;
  type_of_standard?: number;
  mitigation_type?: number;
  sectoral_scopes?: number[];
  project_title?: string;
  attachment_checks?: AttachmentChecks;
  proponent_name: string;
  affiliation?: number;
  authorized_officer?: string;
  contact_info?: string;
  submission_date?: string;
  signature?: string;
}

export interface NmethProposalUpdate {
  title?: string;
  type_of_standard?: number | null;
  mitigation_type?: number | null;
  sectoral_scopes?: number[];
  project_title?: string;
  attachment_checks?: AttachmentChecks;
  proponent_name?: string;
  affiliation?: number;
  authorized_officer?: string;
  contact_info?: string;
  submission_date?: string;
  signature?: string;
}

// ========== API ==========

const nmethProposalService = {
  getList: async (): Promise<NmethProposalDetail[]> => {
    const response = await axios.get<NmethProposalDetail[]>(`${BASE_URL}/`);
    return response.data;
  },

  getById: async (id: number): Promise<NmethProposalDetail> => {
    const response = await axios.get<NmethProposalDetail>(`${BASE_URL}/${id}`);
    return response.data;
  },

  create: async (data: NmethProposalCreate): Promise<NmethProposalDetail> => {
    const response = await axios.post<NmethProposalDetail>(`${BASE_URL}/`, data);
    return response.data;
  },

  update: async (id: number, data: NmethProposalUpdate): Promise<NmethProposalDetail> => {
    const response = await axios.put<NmethProposalDetail>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/${id}`);
  },

  submit: async (id: number): Promise<NmethProposalDetail> => {
    const response = await axios.post<NmethProposalDetail>(`${BASE_URL}/${id}/submit`);
    return response.data;
  },
};

export default nmethProposalService;
